import { useSnapshot } from 'valtio';
import { useStoreActions } from '../store/actions';
import { AppStore } from '../store/store';
import { FaChevronRight, FaChevronLeft } from "react-icons/fa6";
import { LazyLoadImage } from 'react-lazy-load-image-component';

import cls from '../styles/Block.module.scss';
import 'react-lazy-load-image-component/src/effects/blur.css';

const BlockP = () => {
  const {
    onHoverOverFloor,
    incrementSelectedFloor,
    decrementSelectedFloor,
    goPrevPage,
  } = useStoreActions();

  const { selectedFloor } = useSnapshot(AppStore);

  const onNextPage = (floor: number) => {
    AppStore.currentPage = 32;
    AppStore.selectedFloor = floor;
  };

  const onClickBack = () => {
    goPrevPage(10)
    AppStore.selectedFloor = 2
  };

  return (
    <div className={cls.mainContainer}>
      <div onClick={onClickBack} className={cls.mobileNavigationButton}>
        <img src="./images/arrow.png" alt="Назад" />
        <p>К выбору блока</p>
      </div>

      <div className={cls.infoContainer}>
        <div className={cls.selectionScreen}>
          <div className={cls.selectionBody}>
            <button onClick={decrementSelectedFloor} className={cls.arrowButton}>
              <FaChevronLeft />
            </button>
            <div className={cls.selectedBlock}>
              <p>Этаж</p>
              <p>{selectedFloor}</p>
            </div>
            <button onClick={() => incrementSelectedFloor(12)} className={cls.arrowButton}>
              <FaChevronRight />
            </button>
          </div>
        </div>

        <div className={cls.detailsContainer}>
          <div className={cls.detailItem}>
            <div className={cls.imageWrapper}>
              <LazyLoadImage
                src="./images/rooms/1.png"
                effect="blur"
              />
            </div>
            <div className={cls.textWrapper}>
              <p>1-комнатные</p>
              <p><span>Количество на этаже:</span> <span>8</span></p>
            </div>
          </div>
          <div className={cls.detailItem}>
            <div className={cls.imageWrapper}>
              <LazyLoadImage
                src="./images/rooms/2.png"
                effect="blur"
              />
            </div>
            <div className={cls.textWrapper}>
              <p>2-комнатные</p>
              <p><span>Количество на этаже:</span> <span>18</span></p>
            </div>
          </div>
          <div className={cls.detailItem}>
            <div className={cls.imageWrapper}>
              <LazyLoadImage
                src="./images/rooms/3.png"
                effect="blur"
              />
            </div>
            <div className={cls.textWrapper}>
              <p>3-комнатные</p>
              <p><span>Количество на этаже:</span> <span>6</span></p>
            </div>
          </div>
        </div>

        <button onClick={() => onNextPage(selectedFloor)} className={cls.selectButton}>
          Выбрать
        </button>
      </div>

      <div className={cls.imageContainer}>
        <div className={cls.imageBody}>
          <svg viewBox="0 0 1180 837.33331">
            <path
              onClick={() => onNextPage(2)}
              onMouseOver={() => onHoverOverFloor(2)}
              fill="#3292ffcc"
              className={cls.floor2}
              d="m 415.57667,746.23506 215.16428,-9.99878 13.44986,0.82867 4.78075,0.12748 10.45392,0.0638 20.10096,1.94743 335.16576,31.19079 V 744.25188 L 646.53272,687.27912 415.03578,706.02965 Z"
            />
            <circle className={`${cls.symbol2} ${cls.hidden}`} cx="800" cy="730" r="35" fill="#333333" />
            <text className={`${cls.symbol2} ${cls.hidden}`} x="800" y="725" fontFamily="Arial" fontSize="16" textAnchor="middle" fill="white">Этаж</text>
            <text className={`${cls.symbol2} ${cls.hidden}`} x="800" y="750" fontFamily="Arial" fontSize="24" textAnchor="middle" fill="white">2</text>

            <path
              onClick={() => onNextPage(3)}
              onMouseOver={() => onHoverOverFloor(3)}
              fill="#3292ffcc"
              className={cls.floor3}
              d="m 415.57667,698.09668 231.03639,-14.25748 368.30934,61.44864 -0.1275,-30.08688 -368.08189,-81.28879 -231.99844,27.48936 z"
            />
            <circle className={`${cls.symbol3} ${cls.hidden}`} cx="800" cy="685" r="35" fill="#333333" />
            <text className={`${cls.symbol3} ${cls.hidden}`} x="800" y="680" fontFamily="Arial" fontSize="16" textAnchor="middle" fill="white">Этаж</text>
            <text className={`${cls.symbol3} ${cls.hidden}`} x="800" y="705" fontFamily="Arial" fontSize="24" textAnchor="middle" fill="white">3</text>

            <path
              onClick={() => onNextPage(4)}
              onMouseOver={() => onHoverOverFloor(4)}
              fill="#3292ffcc"
              className={cls.floor4}
              d="m 416.0274,652.03167 230.59547,-25.0608 368.20453,85.09856 V 684.57466 L 646.61306,585.41939 415.21608,614.62076 Z"
            />
            <circle className={`${cls.symbol4} ${cls.hidden}`} cx="800" cy="640" r="35" fill="#333333" />
            <text className={`${cls.symbol4} ${cls.hidden}`} x="800" y="635" fontFamily="Arial" fontSize="16" textAnchor="middle" fill="white">Этаж</text>
            <text className={`${cls.symbol4} ${cls.hidden}`} x="800" y="660" fontFamily="Arial" fontSize="24" textAnchor="middle" fill="white">4</text>

            <path
              onClick={() => onNextPage(5)}
              onMouseOver={() => onHoverOverFloor(5)}
              fill="#3292ffcc"
              className={cls.floor5}
              d="M 416.38799,605.42579 647.12301,575.60291 1015.1429,680.87865 V 656.44887 L 646.71301,532.76748 413.68358,568.28531 Z"
            />
            <circle className={`${cls.symbol5} ${cls.hidden}`} cx="800" cy="595" r="35" fill="#333333" />
            <text className={`${cls.symbol5} ${cls.hidden}`} x="800" y="590" fontFamily="Arial" fontSize="16" textAnchor="middle" fill="white">Этаж</text>
            <text className={`${cls.symbol5} ${cls.hidden}`} x="800" y="615" fontFamily="Arial" fontSize="24" textAnchor="middle" fill="white">5</text>

            <path
              onClick={() => onNextPage(6)}
              onMouseOver={() => onHoverOverFloor(6)}
              fill="#3292ffcc"
              className={cls.floor6}
              d="m 414.85549,559.09034 231.63008,-36.9044 367.98123,129.66544 V 628.25496 L 646.74055,476.80064 414.13432,520.77796 Z"
            />
            <circle className={`${cls.symbol6} ${cls.hidden}`} cx="800" cy="550" r="35" fill="#333333" />
            <text className={`${cls.symbol6} ${cls.hidden}`} x="800" y="545" fontFamily="Arial" fontSize="16" textAnchor="middle" fill="white">Этаж</text>
            <text className={`${cls.symbol6} ${cls.hidden}`} x="800" y="570" fontFamily="Arial" fontSize="24" textAnchor="middle" fill="white">6</text>

            <path
              onClick={() => onNextPage(7)}
              onMouseOver={() => onHoverOverFloor(7)}
              fill="#3292ffcc"
              className={cls.floor7}
              d="M 414.20462,512.72005 646.93838,467.72658 1014.6037,623.41046 V 597.13228 L 647.34404,420.35444 413.69467,473.74096 Z"
            />
            <circle className={`${cls.symbol7} ${cls.hidden}`} cx="800" cy="510" r="35" fill="#333333" />
            <text className={`${cls.symbol7} ${cls.hidden}`} x="800" y="505" fontFamily="Arial" fontSize="16" textAnchor="middle" fill="white">Этаж</text>
            <text className={`${cls.symbol7} ${cls.hidden}`} x="800" y="530" fontFamily="Arial" fontSize="24" textAnchor="middle" fill="white">7</text>

            <path
              onClick={() => onNextPage(8)}
              onMouseOver={() => onHoverOverFloor(8)}
              fill="#3292ffcc"
              className={cls.floor8}

              d="M 416.0274,461.82196 630.42224,401.45594 1014.0161,594.02222 V 567.92473 L 647.25389,361.66889 414.6752,427.83663 Z"
            />
            <circle className={`${cls.symbol8} ${cls.hidden}`} cx="800" cy="465" r="35" fill="#333333" />
            <text className={`${cls.symbol8} ${cls.hidden}`} x="800" y="460" fontFamily="Arial" fontSize="16" textAnchor="middle" fill="white">Этаж</text>
            <text className={`${cls.symbol8} ${cls.hidden}`} x="800" y="485" fontFamily="Arial" fontSize="24" textAnchor="middle" fill="white">8</text>

            <path
              onClick={() => onNextPage(9)}
              onMouseOver={() => onHoverOverFloor(9)}
              fill="#3292ffcc"
              className={cls.floor9}

              d="m 413.24847,418.98537 233.2371,-65.6557 367.48543,212.25124 -0.09,-26.63837 -367.33158,-223.85891 -232.98214,66.35688 z"
            />
            <circle className={`${cls.symbol9} ${cls.hidden}`} cx="800" cy="425" r="35" fill="#333333" />
            <text className={`${cls.symbol9} ${cls.hidden}`} x="800" y="420" fontFamily="Arial" fontSize="16" textAnchor="middle" fill="white">Этаж</text>
            <text className={`${cls.symbol9} ${cls.hidden}`} x="800" y="445" fontFamily="Arial" fontSize="24" textAnchor="middle" fill="white">9</text>

            <path
              onClick={() => onNextPage(10)}
              onMouseOver={() => onHoverOverFloor(10)}
              fill="#3292ffcc"
              className={cls.floor10}
              d="M 413.82216,371.75151 646.86803,302.14372 1013.8388,532.06617 1013.775,507.5887 646.86803,262.11286 413.31221,334.27039 Z"
            />
            <circle className={`${cls.symbol10} ${cls.hidden}`} cx="800" cy="380" r="35" fill="#333333" />
            <text className={`${cls.symbol10} ${cls.hidden}`} x="800" y="375" fontFamily="Arial" fontSize="16" textAnchor="middle" fill="white">Этаж</text>
            <text className={`${cls.symbol10} ${cls.hidden}`} x="800" y="400" fontFamily="Arial" fontSize="24" textAnchor="middle" fill="white">10</text>

            <path
              onClick={() => onNextPage(11)}
              onMouseOver={() => onHoverOverFloor(11)}
              fill="#3292ffcc"
              className={cls.floor11}
              d="M 414.20462,325.41006 646.80429,254.65489 1014.03,505.35768 1013.9663,478.39422 646.17213,203.37114 413.95402,287.74853 Z"
            />
            <circle className={`${cls.symbol11} ${cls.hidden}`} cx="800" cy="340" r="35" fill="#333333" />
            <text className={`${cls.symbol11} ${cls.hidden}`} x="800" y="335" fontFamily="Arial" fontSize="16" textAnchor="middle" fill="white">Этаж</text>
            <text className={`${cls.symbol11} ${cls.hidden}`} x="800" y="360" fontFamily="Arial" fontSize="24" textAnchor="middle" fill="white">11</text>

            <path
              onClick={() => onNextPage(12)}
              onMouseOver={() => onHoverOverFloor(12)}
              fill="#3292ffcc"
              className={cls.floor12}
              d="m 414.07713,278.94112 232.53593,-84.14129 367.60824,283.65814 0.5099,-27.34592 -384.9464,-317.76086 -215.45269,98.41982 c 0,0 -0.50995,94.34023 -0.25498,47.17011 z"
            />
            <circle className={`${cls.symbol12} ${cls.hidden}`} cx="800" cy="290" r="35" fill="#333333" />
            <text className={`${cls.symbol12} ${cls.hidden}`} x="800" y="285" fontFamily="Arial" fontSize="16" textAnchor="middle" fill="white">Этаж</text>
            <text className={`${cls.symbol12} ${cls.hidden}`} x="800" y="310" fontFamily="Arial" fontSize="24" textAnchor="middle" fill="white">12</text>
          </svg>

          <LazyLoadImage
            src="./images/blockP.png"
            alt="Структура"
            effect="blur"
            placeholderSrc='./images/placeholder/blockP.png'
          />

          <div onClick={onClickBack} className={cls.navigationButton}>
            <img src="./images/arrow.png" alt="Назад" />
            <p>К выбору блока</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlockP;
